import PropTypes from 'prop-types';
import { mapProps } from 'recompose';
import compose from 'lodash.flowright';

import withModal from '../../../../components/global/modal/withModal';
import PrintProductGroupConfigurator from './PrintProductGroupConfigurator';
import { ORIENTATION } from '../../../cards/constants';

export const PRINT_PRODUCT_CONFIGURATOR_MODAL =
  'PRINT_PRODUCT_CONFIGURATOR_MODAL';

const propTypes = {
  printProducts: PropTypes.arrayOf(
    PropTypes.shape({
      printProductId: PropTypes.string.isRequired,
      printProductSizeId: PropTypes.string,
      orientation: PropTypes.oneOf(Object.values(ORIENTATION)),
    }),
  ),
  photoId: PropTypes.string,
};

const PrintProductGroupConfiguratorModal = withModal(
  compose(
    mapProps(({ onRequestClose, actionProps = {}, ...props }) => ({
      onClose: onRequestClose,
      ...actionProps,
      ...props,
    })),
  )(PrintProductGroupConfigurator),
  {
    name: PRINT_PRODUCT_CONFIGURATOR_MODAL,
    dismissible: false,
    type: 'full',
    hideHeader: true,
    className: 'print-product-configurator-modal',
  },
);

PrintProductGroupConfiguratorModal.propTypes = propTypes;

export default PrintProductGroupConfiguratorModal;
